module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box clearfix "
  }, [_c('div', {
    staticClass: "box-wrap"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "list"
  }, [_c('ul', {
    staticClass: "list_log clearfix"
  }, _vm._l((_vm.res), function(n) {
    return _c('li', [_c('a', {
      directives: [{
        name: "sore",
        rawName: "v-sore",
        value: (n.link),
        expression: "n.link"
      }]
    }, [_c('div', {
      staticClass: "list_a"
    }, [_c('img', {
      attrs: {
        "src": n.image,
        "alt": ""
      }
    })]), _vm._v(" "), _c('span', {
      staticClass: "list_b"
    }, [_vm._v(_vm._s(n.title))])])])
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "aaa"
  }), _vm._v(" "), _c('div', {
    staticClass: "wrap"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "list"
  }, [_c('ul', {
    staticClass: "list_log"
  }, _vm._l((_vm.now), function(item) {
    return _c('li', [_c('a', {
      directives: [{
        name: "sing",
        rawName: "v-sing",
        value: (item.link),
        expression: "item.link"
      }]
    }, [_c('div', {
      staticClass: "list_a"
    }, [_c('img', {
      attrs: {
        "src": item.image,
        "alt": ""
      }
    })]), _vm._v(" "), _c('span', {
      staticClass: "list_b"
    }, [_vm._v(_vm._s(item.title))])])])
  }))])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrap_a"
  }, [_c('h3', [_vm._v("正在流行")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrap_a"
  }, [_c('h3', [_vm._v("畅销热卖")]), _vm._v(" "), _c('p')])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-103b2d61", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-103b2d61","hasScoped":false}!./node_modules/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./app/component/xsubcategory.vue
// module id = 208
// module chunks = 0